module.exports = __webpack_public_path__ + "static/media/pencil-outline.2e921c98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pencil-outline.svg
// module id = 843
// module chunks = 0